import { getLimitValue, getGridValue } from '@common/Listing/helpers';
import { getGroups, getItems } from './filterItemHelpers';

export const getActiveFilters = filters => filters.filter(({ filterType }) => filterType !== 'personalcategory');

export const getActiveFiltersByType = (filters, type) => {
    const filtersByType = filters.filter(({ filterType }) => filterType === type);

    return getActiveFilters(filtersByType);
};

export const formatType = (type) => {
    if (type.indexOf('tag-') > -1) {
        return 'tag';
    }

    return type;
};

const isTagFilter = type => formatType(type) === 'tag';

export const prepareForDisplay = ({
    filterTypes,
    hasMultipleGroups,
    dropdownFilters,
    availableFilters
}) => filterTypes.reduce((filterGroups, filterTypeElement) => {
    const rawItems = dropdownFilters[filterTypeElement];
    const availableItems = availableFilters[filterTypeElement];

    if (hasMultipleGroups) {
        const { list, items } = getGroups(rawItems, availableItems);

        filterGroups.items = {
            ...filterGroups.items,
            ...items
        };

        filterGroups.list.push(...list);
    } else {
        filterGroups.items[filterTypeElement] = getItems({
            rawItems,
            availableItems,
            isSortable: filterTypeElement === 'size'
        });

        filterGroups.list.push(filterTypeElement);
    }

    return filterGroups;
}, { list: [], items: {} });

const getTagFilters = allFilters => Object.keys(allFilters)
    .filter(isTagFilter)
    .reduce((tagFilters, key) => tagFilters.concat(allFilters[key]), []);

export const getActiveFiltersQuery = (activeFilters, limitObject, page, gridView, sortBy) => {
    const params = {
        page: Number(page) || 1,
        grid: getGridValue(gridView),
        limit: getLimitValue(limitObject)
    };
    const tmpParams = {
        age: [],
        brand: [],
        color: [],
        dyncategory: [],
        gender: [],
        length: [],
        order: [],
        personalcategory: [],
        pricerange: [],
        'pricerange-minmax': [],
        scroll: [],
        size: [],
        subcategory: [],
        tag: [],
        topcat: [],
        search_key: []
    };

    const searchQuery = new URLSearchParams(window.location.search);
    const searchKey = searchQuery.get('search_key');

    if (searchKey) {
        tmpParams.search_key.push(searchKey);
    }

    activeFilters.forEach((filterItem) => {
        let tmpFilter = filterItem.filterType;

        if (tmpFilter === 'personalcategory') {
            return;
        }

        if (filterItem.filterType.substr(0, 3) === 'tag') {
            tmpFilter = 'tag';
        }

        tmpParams[tmpFilter].push(filterItem.value);
    });

    sortBy?.forEach((orderItem) => {
        if (orderItem.selected) {
            switch (orderItem.value) {
                case '-1':
                    delete tmpParams.order;
                    break;
                case 'personalcategory':
                    delete tmpParams.order;
                    tmpParams.personalcategory.push(1);
                    break;

                default: {
                    if (!tmpParams.order) {
                        tmpParams.order = [];
                    }

                    tmpParams.order.push(orderItem.value);
                }
            }
        }
    });

    const paramsKeys = [...Object.keys(tmpParams), ...Object.keys(params)];

    return paramsKeys.sort().reduce((paramsObj, parameterName) => {
        if (tmpParams[parameterName]) {
            const parameterItems = tmpParams[parameterName];

            if (parameterItems.length > 0) {
                paramsObj[parameterName] = parameterItems.join(',');
            }
        } else {
            paramsObj[parameterName] = params[parameterName];
        }

        return paramsObj;
    }, {});
};

export const getActiveFiltersFromUrlQuery = (query, allFilters) => {
    const queryKeys = Object.keys(query);
    const tagFilters = getTagFilters(allFilters);

    return queryKeys.reduce((acc, key) => {
        const filterGroup = isTagFilter(key) ? tagFilters : allFilters[key];

        if (filterGroup) {
            const queryParameterValue = query[key].split(',');

            queryParameterValue.forEach((paramSingleValue) => {
                const filtersToLoopThrough = filterGroup?.options ?? filterGroup;
                const filter = filtersToLoopThrough.find(filterObj => filterObj.value === paramSingleValue);

                if (filter) {
                    acc.push(filter);
                }
            });
        }

        return acc;
    }, []);
};
